import * as React from "react"

import { cn } from "@/lib/utils"

function Card({
  className,
  size = "default",
  ...props
}: React.ComponentProps<"div"> & { size?: "default" | "sm" }) {
  return (
    <div
      data-slot="card"
      data-size={size}
      className={cn(
        "tw:group/card! tw:flex! tw:flex-col! tw:gap-4! tw:overflow-hidden! tw:rounded-lg! tw:bg-card! tw:py-4! tw:text-xs/relaxed! tw:text-card-foreground! tw:ring-1 tw:ring-foreground/10 tw:has-[!>img:first-child]:pt-0 tw:data-[size=sm]:gap-3! tw:data-[size=sm]:py-3! tw:*:[img:first-child]:rounded-t-lg! tw:*:[img:last-child]:rounded-b-lg!",
        className
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        "tw:group/card-header! tw:@container/card-header! tw:grid! tw:auto-rows-min! tw:items-start! tw:gap-1! tw:rounded-t-lg! tw:px-4! tw:group-data-[size=sm]/card:px-3! tw:has-data-[slot=card-action]:grid-cols-[1fr_auto]! tw:has-data-[slot=card-description]:grid-rows-[auto_auto]! tw:[.border-b]:pb-4! tw:group-data-[size=sm]/card:[.border-b]:pb-3!",
        className
      )}
      {...props}
    />
  )
}

function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-title"
      className={cn("tw:font-heading tw:text-xl!", className)}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-description"
      className={cn("tw:text-xs/relaxed! tw:text-muted-foreground!", className)}
      {...props}
    />
  )
}

function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-action"
      className={cn(
        "tw:col-start-2! tw:row-span-2! tw:row-start-1! tw:self-start! tw:justify-self-end!",
        className
      )}
      {...props}
    />
  )
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("tw:px-4! tw:group-data-[size=sm]/card:px-3!", className)}
      {...props}
    />
  )
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn(
        "tw:flex! tw:items-center! tw:rounded-b-lg! tw:px-4! tw:group-data-[size=sm]/card:px-3! tw:[.border-t]:pt-4! tw:group-data-[size=sm]/card:[.border-t]:pt-3!",
        className
      )}
      {...props}
    />
  )
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
}
